export const baseUrl='https://api.themoviedb.org/3';
export const API_KEY='03a19843bb78a77b03df004a35377575';
export const imageUrl='https://image.tmdb.org/t/p/original'
